import { useNumber } from './state-basic';

export const useWidthAndHeightFile = () => {
  const videoWidth = useNumber(0);
  const videoHeight = useNumber(0);
  const thumbnailWidth = useNumber(0);
  const thumbnailHeight = useNumber(0);

  const handleGetWidthAndHeightVideo = (e: any) => {
    if (e.target?.videoWidth && e.target?.videoHeight) {
      videoWidth.setValue(e.target.videoWidth);
      videoHeight.setValue(e.target.videoHeight);
    }
  };

  const handleGetWidthAndHeightThumbnail = (e: any) => {
    if (e.target.naturalWidth && e.target?.naturalHeight) {
      thumbnailWidth.setValue(e.target.naturalWidth);
      thumbnailHeight.setValue(e.target.naturalHeight);
    }
  };

  return {
    videoWidth,
    videoHeight,
    thumbnailWidth,
    thumbnailHeight,
    handleGetWidthAndHeightVideo,
    handleGetWidthAndHeightThumbnail,
  };
};
